/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Old/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import CoreEmbeddableSection from 'DesignSystem/CoreEmbeddableSection/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Old({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/Old"
  
}) {
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'id',
})
let constantData = 'ledger'
let tabSelectedLedgerPayorValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.payor',
})
let aggregateData = fromHelpers.getParams(patientIdValueData, constantData, tabSelectedLedgerPayorValueData)
let globalRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'refresh_embedded_section',
})
let globalSessionExpiredRefreshEmbeddedSectionValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'session_expired_refresh_embedded_section',
})
  return (<React.Fragment
>
<CoreEmbeddableSection
  viewPath={`${viewPath}/CoreEmbeddableSection`}
 section_type="patients"
 data="global.current_location._id"
 location_id={globalCurrentLocationIdValueData}
 data="patient.id"
 data="'ledger'"
 data="tab.selected.ledger.payor"
 aggregate="helpers.js getParams"
 params={aggregateData}
 data="global.refresh_embedded_section"
 refresh={globalRefreshEmbeddedSectionValueData}
 data="global.session_expired_refresh_embedded_section"
 session_expired_refresh={globalSessionExpiredRefreshEmbeddedSectionValueData}
/>
{children}
</React.Fragment>)
}